






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { FlowStatValueType } from '../../logic/Editor/types'
import { FlowStatistics } from '../../logic/FlowStatistics'
import { CustomNode } from '../../logic/Nodes'
import { CustomOutput } from '../Socket'
import { SELF_NODE_ITEM } from '../Socket/SocketsHelper'

@Component({
  data() {
    return {
      SELF_NODE_ITEM,
      FlowStatValueType
    }
  }
})
export default class OutputConnectionStatValue extends Vue {
  @Prop() output!: CustomOutput

  @Prop() node!: CustomNode

  @Prop() statistics!: FlowStatistics

  get i18n() {
    return CustomNode.i18n
  }

  get outputConnection() {
    return this.output.connections[0]
  }

  get percent() {
    const output = this.outputConnection

    if (output) {
      const { statistics } = output.data

      if (statistics) {
        if (this.statistics.statSetting.valueType === FlowStatValueType.Fixed) {
          return statistics.value * 100 / this.node.inputConnectionsTotalValue()
        } else {
          return statistics.value
        }
      }

      return 0
    }

    return 0
  }
}
